import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import { AppBarTitle } from '@components/app-bar-title';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { FcSearch, HandShakeIcon } from '@icon/react-icons';
import { Link } from 'react-router-dom';
import { AvatarProps, Avatar, IconButton, Grid, Tooltip } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/House';
import LoginPage from '../login';

const useStyles = makeStyles({
  root: {
    // maxWidth: 200,
    // boxShadow:
    //   '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%),0px 1px 5px 0px rgb(0 0 0 / 12%)',
  },
  media: {
    height: 150,
  },
});

export interface CardProps {
  imageUrl: string;
  cardLabel: string;
  buttons: { route: string; label: string }[];
  backgroundSize?: 'cover' | 'contain';
}
export function PageCard({ imageUrl, cardLabel, buttons, backgroundSize = null }: CardProps) {
  const classes = useStyles();

  return (
    <Card
      className={classes.root}
      elevation={5}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        width: '100%',
      }}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image={imageUrl}
          title={cardLabel}
          style={{
            backgroundSize: backgroundSize ? backgroundSize : 'contain',
            backgroundPosition: 'center center',
          }}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {cardLabel}
          </Typography>
          {/* <Typography variant="body2" color="textSecondary" component="p">
            Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging
            across all continents except Antarctica
          </Typography> */}
        </CardContent>
      </CardActionArea>
      <CardActions>
        {buttons.map((x, index) => (
          <Link to={x.route} style={{ textDecoration: 'none' }} key={index}>
            <Button size="small" color="primary" className={x.route.slice(1).replace('/', '-')}>
              {x.label}
            </Button>
          </Link>
        ))}
      </CardActions>
    </Card>
  );
}

const allCategories: CardProps[] = [
  {
    imageUrl: '/images/Deals.jpg',
    cardLabel: 'Deals Intel',
    buttons: [
      {
        label: 'Search',
        route: '/deals/search',
      },
      {
        label: 'New',
        route: '/deals/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Companies.jpg',
    cardLabel: 'Companies',
    buttons: [
      {
        label: 'Search',
        route: '/company/search',
      },
      {
        label: 'New',
        route: '/company/new',
      },
      {
        label: 'Search Request',
        route: '/company-request/search',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/content.jpg',
    cardLabel: 'Content',
    buttons: [
      {
        label: 'Search',
        route: '/content/search',
      },
      {
        label: 'New',
        route: '/content/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Company to Content.jpg',
    cardLabel: 'Company to Content Relations',
    buttons: [
      {
        label: 'Search',
        route: '/company-content/search',
      },
      {
        label: 'New',
        route: '/company-content/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Company to Company.jpg',
    cardLabel: 'Company to Company Relations',
    buttons: [
      {
        label: 'Search',
        route: '/company-mapping/search',
      },
      {
        label: 'New',
        route: '/company-mapping/new',
      },
    ],
    backgroundSize: 'cover',
  },

  {
    imageUrl: '/images/Service Management.jpg',
    cardLabel: 'Services Management',
    buttons: [
      {
        label: 'Search',
        route: '/service-management/search',
      },
      {
        label: 'New',
        route: '/service-management/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Deal Sub Type Management.jpg',
    cardLabel: 'Deal SubType Management',
    buttons: [
      {
        label: 'Search',
        route: '/deal-subtype-master/search',
      },
      {
        label: 'New',
        route: '/deal-subtype-master/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Region Country Management.jpg',
    cardLabel: 'Territory Management',
    buttons: [
      {
        label: 'Search',
        route: '/region-country-master/search',
      },
      {
        label: 'New',
        route: '/region-country-master/new',
      },
    ],
    backgroundSize: 'cover',
  },
  {
    imageUrl: '/images/Cosmos API.jpg',
    cardLabel: 'COSMOS',
    buttons: [
      {
        label: 'Search',
        route: '/holding-data/search',
      },
      {
        label: 'Seller Catalogue',
        route: '/seller-catalog/search',
      },
    ],
    backgroundSize: 'cover',
  },
];
export default function DefaultErrorPage() {
  return (
    <div>
      <AppBarTitle>
        <IconButton onClick={null} color="inherit" edge="start">
          <HomeIcon />
        </IconButton>
        Default Error Page
      </AppBarTitle>
      <Grid
        container
        style={{ display: 'flex', height: '300px', justifyContent: 'center', alignItems: 'center' }}
        justify="center">
        <Typography variant="h5" style={{ color: 'red' }}>
          You don't have Access to this page,
          <br />
          Please Login with required credentials
          <br />
          
          <Link style={{ textDecoration: 'none' }} to="/landing-page">
            {' '}
            <Button color="primary" variant="contained">
              Home
            </Button>
          </Link>
        </Typography>
        <br />
      </Grid>
      {/* <Grid container alignItems="stretch" spacing={2} justify="center">
        {allCategories.map((val, index) => (
          <Grid item xs={3} style={{ display: 'flex' }} key={index}>
            <PageCard
              imageUrl={val.imageUrl}
              cardLabel={val.cardLabel}
              buttons={val.buttons}
              backgroundSize={val.backgroundSize}
              key={index}
            />
          </Grid>
        ))}
      </Grid> */}
    </div>
  );
}
